/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPartlyCloudyDayIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-partly-cloudy-day"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18.13 20L16.73 18.57Q16.35 18.18 16.35 17.64Q16.35 17.1 16.73 16.73Q17.1 16.35 17.64 16.35Q18.18 16.35 18.57 16.73L20 18.13Q20.4 18.52 20.4 19.06Q20.4 19.6 20 20Q19.6 20.4 19.06 20.4Q18.52 20.4 18.13 20ZM6 20Q4.35 20 3.17 18.82Q2 17.65 2 16Q2 14.35 3.17 13.18Q4.35 12 6 12Q7.2 12 8.2 12.64Q9.2 13.28 9.68 14.4L9.93 14.97L10.47 14.97Q11.53 14.97 12.25 15.71Q12.97 16.45 12.97 17.5Q12.97 18.55 12.25 19.27Q11.53 20 10.47 20ZM14.95 17.2Q14.78 15.63 13.76 14.44Q12.75 13.25 11.2 13.03Q10.55 11.57 9.19 10.79Q7.83 10 6.25 10Q6.9 8.18 8.47 7.09Q10.05 6 12 6Q14.5 6 16.25 7.75Q18 9.5 18 12Q18 13.63 17.19 15.01Q16.38 16.4 14.95 17.2ZM20 13.32Q19.45 13.32 19.06 12.94Q18.68 12.55 18.68 12Q18.68 11.45 19.06 11.06Q19.45 10.68 20 10.68L22 10.68Q22.55 10.68 22.94 11.06Q23.32 11.45 23.32 12Q23.32 12.55 22.94 12.94Q22.55 13.32 22 13.32ZM5.42 7.28L4 5.85Q3.63 5.47 3.63 4.92Q3.63 4.38 4 4Q4.4 3.6 4.94 3.6Q5.47 3.6 5.88 4L7.28 5.42Q7.65 5.83 7.65 6.36Q7.65 6.9 7.28 7.28Q6.9 7.65 6.35 7.65Q5.8 7.65 5.42 7.28ZM16.73 7.28Q16.35 6.9 16.35 6.36Q16.35 5.83 16.73 5.42L18.13 4Q18.52 3.6 19.06 3.6Q19.6 3.6 20 4Q20.38 4.38 20.38 4.92Q20.38 5.47 20 5.85L18.57 7.28Q18.2 7.65 17.65 7.65Q17.1 7.65 16.73 7.28ZM12 5.33Q12 5.33 11.72 5.33Q11.45 5.33 11.06 4.94Q10.68 4.55 10.68 4L10.68 2Q10.68 1.45 11.06 1.06Q11.45 0.68 12 0.68Q12.55 0.68 12.94 1.06Q13.32 1.45 13.32 2L13.32 4Q13.32 4.55 12.94 4.94Q12.55 5.33 12 5.33Z" fill={color} />
    </svg>
  );
}
